import {
  shape, string, number, bool, arrayOf, id
} from '@thd-nucleus/data-sources';

const taskParams = shape({
  id: id(),
  name: string(),
  value: string(),
  paramType: string(),
});

const taskRewards = shape({
  id: id(),
  rewardId: id(),
  rewardDetailId: id(),
  name: string(),
  description: string(),
  activeImageUrl: string(),
  inactiveImageUrl: string(),
  rewardType: string(),
  availability: string(),
  activationType: string(),
  amount: number(),
  expiryPeriod: number(),
});

const challengeMetaDataEntry = shape({
  key: string(),
  value: string(),
});

const challengeSteps = shape({
  customerTaskId: id(),
  name: string(),
  description: string(),
  url: string(),
  sequenceNumber: number(),
  completed: bool(),
});

const challengeTasks = shape({
  id: id(),
  name: string(),
  challengeStepId: id(),
  customerChallengeStepId: id(),
  description: string(),
  sequenceNumber: number(),
  taskType: string(),
  taskSubType: string(),
  status: string(),
  params: arrayOf(taskParams),
  metaData: string(),
});

const challenges = shape({
  id: id(),
  svocId: id(),
  name: string(),
  description: string(),
  instructionsOverview: string(),
  imageUrl: string(),
  termsAndConditions: string(),
  startDate: string(),
  endDate: string(),
  challengeStatus: string(),
  optedStatus: string(),
  optedTimeStamp: string(),
  activityStatus: string(),
  daysLeft: number(),
  tasks: arrayOf(challengeTasks),
  rewards: arrayOf(taskRewards),
  challengeMetaData: string(),
  customerChallengeId: id(),
  inactiveImageUrl: string(),
  challengeStepsCompleted: number(),
  challengeStepsTotal: number(),
  v2Challenge: bool(),
  challengeSteps: arrayOf(challengeSteps),
});

const userProfile = shape({
  emails: arrayOf(shape({ emailAddress: string() })),
  name: shape({ firstName: string(), lastName: string() }),
  phones: arrayOf(shape({ number: string() })),
});

export const offeredChallengesV2Model = {
  challenges: arrayOf(challenges),
  userProfile,
};

export const COMMON_CHALLENGE_MODELS = {
  taskParams,
  taskRewards,
  challengeMetaDataEntry,
  challengeSteps,
  challengeTasks,
  challenges,
  userProfile,
};
